/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Video_Export_Preset_Delete_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"?" |
*
* @param {Video_Export_Preset_Delete_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_delete_text = /** @type {((inputs: Video_Export_Preset_Delete_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Delete_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Voulez-vous supprimer "${i?.name}" ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare "${i?.name}"?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.name}"?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar "${i?.name}"?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除“${i?.name}”吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」を削除してもよろしいですか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.name}" को हटाना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.name}"?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"?`)
});